import React from 'react';
import MainPage from './MainPage';

const Party = () => {
  return <MainPage tag='PARTY' title='PARTY_SELECTION' url='/party-selection'/>;
}

export default Party;